module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOBAMAAADtZjDiAAAAG1BMVEUAAABVYrRVYrRVYrRVYrRVYrRVYrRVYrRVYrT8iFwpAAAACXRSTlMA/AGRSHNJ7W/zcg8rAAAALElEQVQI12MAAqYIBjBQFgdTTIZiEK5gAirXAUwHijDAaJg4VBumAMJcmD0AHgUFA2i9R8gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paySystem/icon_arrow_left.png
// module id = sgn6
// module chunks = 1